<template>
    <div :class="{'error': getError}">
        <slot></slot>
        <div v-if="getError" class="form-control-feedback">{{getError}}</div>
    </div>
</template>

<script>
export default
{
    name: 'InputValidation',
    props: ['formerror', 'name'],
    computed:
    {
        getError()
        {
            const me = this;

            const fieldName = me.name;

            if (me.formerror && me.formerror.errors)
            {
                if (me.formerror.code === 'field_errors')
                {
                    for (const error of me.formerror.errors)
                    {
                        if (error.params && error.params.field === fieldName)
                        {
                            return me.$t(`${error.notice.toUpperCase()}_${error.params.field.toUpperCase()}`);
                        }
                    }
                }
                else
                {
                    for (const error of me.formerror.errors)
                    {
                        if (error.params && error.params.field && error.params.field === fieldName)
                        {
                            return me.$t(error.notice.toUpperCase(), error.params);
                        }
                    }
                }
            }

            if (me.formerror.params && me.formerror.params.field === fieldName)
            {
                return me.$t(me.formerror.notice.toUpperCase(), me.formerror.params);
            }

            return false;
        },
    },
};
</script>
